import React from 'react'

const OurApproch = () => {
    return (
        <div>
            <h1>what’s new in our approach?</h1>
            <hr />
            <ol>
                <li>Creating together: You will create and learn with a dedicated peer group.
                    <ul>
                        <li>A new way of learning: This will be a new kind of project-based learning where while creating those projects, you will learn about web development, React, React ecosystem, using different tools like React Router.</li>
                        <li>Action-based and job-oriented: There won’t be any theory or documentation that you will just read or listen to and do nothing about it. This new form of learning is more action-based.</li>
                        <li>For everyone and anyone: The best part of neoG.camp is its duality in value:</li>
                    </ul>
                </li>
                <li>Where can I know about all the updates on the camp?
                    <p>It’s beginner-friendly as even if you don’t know anything about programming, you can join and learn. The levelZero will start from level zero, i.e. ground level.
                        In short, neoG.camp is a project-based, advanced fullstack web development boot camp to get you from an absolute beginner to a job. The result would be making programming fun for you and increasing your overall value.
                    </p>
                    <ul>
                        <li><a href="https://instagram.com">Instagram</a></li>
                        <li><a href="https://twitter.com">Twitter</a></li>
                        <li><a href="https://Linkedin.com">Linkedin</a></li>
                        <li><a href="https://discord.com/invite/4RCncKrDUX">#teamtanay Discord.</a></li>
                    </ul>
                </li>
            </ol>
        </div>
    )
}

export default OurApproch